import { SelectOptionTypes } from "../../components/Input";
import { isAfterLocalToday } from "../../utils";
import {
  LiabilityPaymentFrequency,
  LiabilityRateTypes,
  LiabilityStatus,
} from "./types";

export const STATUS_OPTIONS = [
  { label: "Active", value: LiabilityStatus.ACTIVE },
  { label: "Closed", value: LiabilityStatus.CLOSED },
  { label: "Defaulted", value: LiabilityStatus.DEFAULTED },
] as SelectOptionTypes[];

export const RATE_TYPE_OPTIONS = [
  { value: "0", label: LiabilityRateTypes.FIXED },
  { value: "1", label: LiabilityRateTypes.VARIABLE },
] as SelectOptionTypes[];

export const RATE_TYPE_SEGMENTS = [
  { value: LiabilityRateTypes.VARIABLE, label: LiabilityRateTypes.VARIABLE },
  { value: LiabilityRateTypes.FIXED, label: LiabilityRateTypes.FIXED },
];

export const RESET_FREQUENCY_OPTIONS = [
  { label: "3 months", value: "3" },
  { label: "6 months", value: "6" },
  { label: "12 months", value: "12" },
  { label: "2 years", value: "24" },
  { label: "5 years", value: "60" },
] as SelectOptionTypes[];

export const PAYMENT_FREQUENCY_OPTIONS = [
  { label: "Weekly", value: LiabilityPaymentFrequency.WEEKLY },
  { label: "Biweekly", value: LiabilityPaymentFrequency.BIWEEKLY },
  { label: "Monthly", value: LiabilityPaymentFrequency.MONTHLY },
  { label: "Quarterly", value: LiabilityPaymentFrequency.QUARTERLY },
  { label: "Semiannual", value: LiabilityPaymentFrequency.SEMIANNUAL },
  { label: "Annual", value: LiabilityPaymentFrequency.ANNUAL },
] as SelectOptionTypes[];

export const PAYMENT_FREQUENCY_LABELS = PAYMENT_FREQUENCY_OPTIONS.reduce(
  (labels, option) => {
    labels[option.value as LiabilityPaymentFrequency] = option.label;
    return labels;
  },
  {} as Record<LiabilityPaymentFrequency, string>,
);

export const START_DATE_RULES = {
  required: "Start date is required!",
  validate: {
    notInFuture: (value: Date | null) =>
      value && isAfterLocalToday(value)
        ? "Start date cannot be in the future"
        : true,
  },
};
